<div *ngIf="data" class="page-container">
  <app-details-header
    [type]="unitType | titlecase"
    [header]="number"
    [icon]="data.type | icon"
    (onEdit)="onEdit()"
    [useEdit]="canEdit"
  >
    <p>
      <span class="font-14">
        {{ data.agreement ? ('label.agreement' | locCap) + ': ' + data.agreement.agreementNumber : ('agr.noActive' | loc) }}
      </span>
    </p>
    <p *ngIf="data.agreement">
      <mat-icon class="vertical-align-middle font-18">calendar_today</mat-icon>&nbsp;
      <span class="font-14" *ngIf="data.agreement as agr">
        {{
          agr.agreementStartDate | dateTo: agr.agreementEndDate : { toNullValue: ('label.infiniteAgr' | locCap), format: 'dLong' }
        }}
      </span>
    </p>
  </app-details-header>

  <div class="page-section">
    <app-details-section *ngIf="apartment" headerKey="PRSapartment.nominative">
      <app-users-unit-basic-data [apartment]="apartment" (showUnitCodes)="showUnitCodes = true"></app-users-unit-basic-data>
    </app-details-section>

    <app-details-section *ngIf="parking" headerKey="parking.nominative">
      <app-users-unit-basic-data [parking]="parking" (showUnitCodes)="showUnitCodes = true"></app-users-unit-basic-data>
    </app-details-section>

    <app-details-section *ngIf="storage" headerKey="storage.nominative">
      <app-users-unit-basic-data [storage]="storage" (showUnitCodes)="showUnitCodes = true"></app-users-unit-basic-data>
    </app-details-section>

    <app-details-section headerKey="user.noteList">
      <app-notes [refId]="data.unit.id" [type]="NoteType.UNIT" [disableEdit]="!canEdit"></app-notes>
    </app-details-section>

    <app-all-integration-codes [codes]="data.unit.unitCodes" [(show)]="showUnitCodes"></app-all-integration-codes>

    <app-details-section *ngIf="data.agreement" headerKey="agr.residents">
      <app-users-residents-links [residents]="residents"> </app-users-residents-links>
    </app-details-section>

    <!-- <app-details-section header="WIADOMOŚCI">
      <p class="dimmed">Brak wiadomości</p>
    </app-details-section> -->

    <app-details-section *ngIf="data.agreement" headerKey="unit.activeAgr">
      <app-users-prs-agreements-links
        [unitId]="data.unit.id"
        [unitType]="data.type"
        [agreements]="[data.agreement]"
      ></app-users-prs-agreements-links>
    </app-details-section>

    <app-details-section *ngIf="data.futureAgreements?.length" headerKey="agr.future">
      <app-users-prs-agreements-links
        [unitId]="data.unit.id"
        [unitType]="data.type"
        [agreements]="data.futureAgreements"
      ></app-users-prs-agreements-links>
    </app-details-section>

    <app-details-section *ngIf="data.archivedAgreements?.length" headerKey="agr.archivals">
      <app-users-prs-agreements-links
        [unitId]="data.unit.id"
        [unitType]="data.type"
        [agreements]="data.archivedAgreements"
      ></app-users-prs-agreements-links>
    </app-details-section>

    <app-details-section headerKey="logCat.protocol" [last]="true" *ngIf="data.agreement">
      <table class="protocols-view">
        <ng-container *ngFor="let type of PROTOCOL_TYPES">
          <tr>
            <ng-container *ngIf="protocols.get(type) as prot; else ngElse">
              <td>
                <div *ngFor="let attachment of prot.attachments; let i = index" class="margin-bottom">
                  <a [href]="attachment | getStorageURL">
                    {{ protType(type) }} {{ prot.timestamp | lDate: 'dLong' }} ({{ 'label.attachment' | locCap }} {{ i + 1 }})
                  </a>
                </div>
              </td>
              <td>
                <a class="mat-primary cursor-pointer padded" (click)="onEditProtocol(type, prot.id)" *ngIf="canEdit">
                  <mat-icon>edit</mat-icon>
                </a>
                <a class="mat-primary cursor-pointer padded" (click)="onRemoveProtocol(prot)" *ngIf="canEdit">
                  <mat-icon>delete</mat-icon>
                </a>
              </td>
            </ng-container>
            <ng-template #ngElse>
              <td>
                <button
                  mat-stroked-button
                  class="mat-primary button-rounded"
                  type="button"
                  (click)="onAddProtocol(type)"
                  *ngIf="canEdit"
                >
                  + {{ 'button.add' | locCap }} {{ protType(type) }}
                </button>
              </td>
            </ng-template>
          </tr>
        </ng-container>
      </table>
    </app-details-section>
  </div>
</div>
